import { render, staticRenderFns } from "./LevelItem.vue?vue&type=template&id=0ea7c606&scoped=true"
import script from "./LevelItem.vue?vue&type=script&lang=js"
export * from "./LevelItem.vue?vue&type=script&lang=js"
import style0 from "./LevelItem.vue?vue&type=style&index=0&id=0ea7c606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7c606",
  null
  
)

export default component.exports